import { render, staticRenderFns } from "./horizontal-tabs.vue?vue&type=template&id=469cc42e&scoped=true&"
import script from "./horizontal-tabs.vue?vue&type=script&lang=ts&"
export * from "./horizontal-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./horizontal-tabs.vue?vue&type=style&index=0&id=469cc42e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469cc42e",
  null
  
)

export default component.exports